// extracted by mini-css-extract-plugin
module.exports = {"threeDotsPopover":"_1nfWw","popoverLoadingItem":"_2Znb3","threeDotsButton":"_3aPve","popoverButton":"_34MAm","popoverError":"_2ruky","skillTagRowIcon":"_1lvPL"};